<template>
  <div class="account-login-box">
    <div class="form-box">
      <el-form ref="form" :model="dataModel" label-width="0" :rules="rules">
        <el-form-item label="" prop="mobile_phone" :required="false">
          <el-input v-model.trim="dataModel.mobile_phone" :maxlength="11" autofocus @keyup.enter.native="formSubmit" placeholder="输入手机号"></el-input>
        </el-form-item>

        <el-form-item label="" prop="passwd">
          <el-input type="password" v-model.trim="dataModel.passwd" :maxlength="20" @keyup.enter.native="formSubmit" placeholder="输入6-20位密码"></el-input>
        </el-form-item>
        <el-form-item label="" prop="code" v-if="showCheckCode">
          <el-row :gutter="12">
            <el-col :span="15">
              <el-input v-model.trim="dataModel.code" :maxlength="4" @keyup.enter.native="formSubmit" placeholder="输入验证码"></el-input>
            </el-col>
            <el-col :span="9">
              <div class="verify-code-box">
                <verify-code @click.native="createCode" :identifyCode="checkCode"></verify-code>
              </div>
            </el-col>
          </el-row>
        </el-form-item>
        <div class="login-addon">
          <div class="message-login" @click="gotoPhoneLogin">短信验证登录</div>
          <div class="forget" @click="gotoForgetPassword">忘记密码</div>
        </div>
        <el-button class="login-btn" type="primary" @click="formSubmit">登录</el-button>
      </el-form>
    </div>
    <div class="wx-login-box" @click="gotoWxLogin">
      <img class="wx-icon" src="https://o.666visa.cn/static/ssqwxa/register/wx-icon.png" />
      <div class="wx-label">微信登录</div>
    </div>
  </div>
</template>
<script>
import md5 from 'md5';
import Http from '@/libs/http';
import VerifyCode from './verify-code';

export default {
  name: 'wx-qrcode-login',
  components: {
    VerifyCode,
  },
  data() {
    return {
      dataModel: {
        mobile_phone: '',
        passwd: '',
        code: '',
      },
      rules: {
        mobile_phone: [
          { required: true, trigger: 'blur', message: '请输入手机号' },
          { pattern: /^1\d{10}$/, trigger: 'blur', message: '请输入正确手机号' },
        ],
        passwd: [
          { required: true, trigger: 'blur', message: '请输入密码' },
          { min: 6, trigger: 'blur', message: '请输入正确的密码' },
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
        ],
      },
      checkCode: '',
      showCheckCode: false,
    };
  },
  created() {
    this.createCode();
    this.handleIsShowCheckCode();
  },
  mounted() {
  },
  methods: {
    gotoPhoneLogin() {
      this.$emit('change-page', 3);
    },
    gotoForgetPassword() {
      this.$emit('change-page', 4);
    },
    gotoWxLogin() {
      this.$emit('change-page', 1);
    },
    createCode() {
      let code = '';
      const random = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R',
        'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
      for (let i = 0; i < 4; i++) {
        const index = Math.floor(Math.random() * 36);
        code += random[index];
      }
      this.checkCode = code;
    },
    handleIsShowCheckCode(type) {
      let num = +window.localStorage.getItem('loginErrorNum') || 0;
      if (type === 'add') num += 1;
      if (num >= 3) {
        this.showCheckCode = true;
        if (type === 'add') {
          // 校验一下，主要是为了提示需要输入验证码
          this.$nextTick(() => {
            this.$refs.form && this.$refs.form.validate();
          });
        }
      }
      window.localStorage.setItem('loginErrorNum', num);
    },
    formSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.showCheckCode && this.checkCode !== this.dataModel.code.toUpperCase()) {
            this.createCode();
            this.$message.error('验证码错误');
            return false;
          }
          const postData = {
            mobile_phone: this.dataModel.mobile_phone,
            passwd: md5(this.dataModel.passwd),
            login_type: 1,
          };
          Http.post('/sys/peer_login', postData).then((data) => {
            this.$emit('login-success', data);
          }).catch((e) => {
            if (e) console.log(e);
            this.handleIsShowCheckCode('add');
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>

.account-login-box{
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #2F333D;
  font-size: 14px;
  line-height: 1;
  .form-box{
    width: 100%;
    height: 290px;
    /deep/ .el-form-item{
      margin-bottom: 20px;
      .el-input__inner{
        height: 48px;
        color: #2F333D;
        font-size: 16px;
        border-radius:2px;
      }
    }
    .login-addon{
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      margin-bottom: 16px;
      .message-login{
        color: #599FFF;
        cursor: pointer;
      }
      .forget{
        color: #2F333D;
        cursor: pointer;
      }
    }
    .login-btn{
      width: 100%;
      height: 48px;
      font-size: 16px;
      background: #599FFF;
      border-radius:2px;
      &:hover{
        opacity: 0.8;
      }
    }
  }
  .wx-login-box{
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
    .wx-icon{
      width: 48px;
      height: 48px;
    }
    .wx-label{
      margin-top: 8px;
    }
  }
}
.verify-code-box{
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/common/login/components/account-login.vue